module.exports = __webpack_public_path__ + "f3619fed7ef3a5ccf96c1f00da6d9424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_70.jpg
// module id = 1686
// module chunks = 5